import clsx from "clsx";
import type { ReactNode } from "react";
import { Breadcrumbs, type BreadcrumbItem } from "../Breadcrumbs/Breadcrumbs";
import styles from "./PageHeader.module.css";

export interface PageHeaderProps {
  /** The page's single <h1>. */
  title: ReactNode;
  /** One sentence on what the page is for, or key facts. */
  description?: ReactNode;
  /** Key facts next to the title (status badges, a code, counts). */
  meta?: ReactNode;
  /** The page's primary action (one solid accent Button) and secondary actions. */
  actions?: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  className?: string;
}

/** Page anatomy: PageHeader (title, key facts, primary action), then Toolbar, then content. */
export function PageHeader({ title, description, meta, actions, breadcrumbs, className }: PageHeaderProps) {
  return (
    <header className={clsx(styles.header, className)}>
      {breadcrumbs?.length ? <Breadcrumbs items={breadcrumbs} /> : null}
      <div className={styles.row}>
        <div className={styles.heading}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>{title}</h1>
            {meta ? <div className={styles.meta}>{meta}</div> : null}
          </div>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </header>
  );
}
